import { Translate } from "components/common/Translate/Translate";
import { LetterSpacing } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/FontSpacing/FontSpacinOptions/LetterSpacing/LetterSpacing";
import { LineSpacing } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/FontSpacing/FontSpacinOptions/LineSpacing/LineSpacing";
import type { TextBox } from "store/features/memeGenerator/types";

interface SpacingProps {
    textBox: TextBox;
}

export const Spacing = ({ textBox }: SpacingProps) => {
    return (
        <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
                <div>
                    <Translate keyName="letter-spacing" />
                </div>
                <LetterSpacing textBox={textBox} />
            </div>
            <div className="flex flex-col gap-4">
                <div>
                    <Translate keyName="font-spacing" />
                </div>
                <LineSpacing textBox={textBox} />
            </div>
        </div>
    );
};
